import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'propertyFilter',
  standalone: true
})
export class PropertyFilterPipe implements PipeTransform {

  transform(value: any, arg: string): any {
    if (arg) {
      return value.filter((item: any) => {
        arg = arg.trim().toLowerCase();
        return item.titleEn.toLowerCase().includes(arg)
          || item.nameEn?.toLowerCase().includes(arg)
          || item.nameAr?.toLowerCase().includes(arg)
          || item?.propertyNumber.toLowerCase().includes(arg);
      });
    } else {
      return value;
    }
  }

}
